<div class="ag-grid-scroll-container">
  <ag-grid-angular
    #agGridBase
    [rowData]="rowData"
    [columnDefs]="displayColumnDefs"
    [class]="gridTheme"
    [defaultColDef]="defaultColDef"
    [ngStyle]="{
      'width': '100%',
      'height': getGridHeight() || tableHeight || 'auto'
    }"
  >
  </ag-grid-angular>
</div>
